import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen8() {
    const { t } = useLang('theProductV2.Screen8');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen8-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen8-V2"
            data-section-id={'rapid-mag-Screen8-V2'}
            data-section-title={t('title')}
        >
            <div className="label">{t('label')}</div>
            <div className="title">{t('title')}</div>
            <div className="desc">{t('desc')}</div>
            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547878340/Screen8.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547898108/Screen8.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1761547878486/Screen8-m.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1761547898211/Screen8-m.webp',
                    )}
                />
            </div>
        </section>
    );
}
